module.exports = __webpack_public_path__ + "static/img/qrCode.8ba89eda.png";